import axios from "axios";
import BASE_URL from "../../config";


const getAuthHeader = () => {
  const tokenData = JSON.parse(localStorage.getItem("authUser") || "{}");
  return {
    Authorization: `Bearer ${tokenData.accessToken}`
  };
};

export const getCountries = async (filter = {}) => {
  try {
    const response = await axios.post(`${BASE_URL}/api/Country/get`, filter, {
      headers: getAuthHeader(),
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching countries:", error);
    throw error;
  }
}; 